import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './containers/Home';
import Story from './containers/Story';
import Offerings from './containers/Offerings';
import Contact from './containers/Contact';
import AdminLogin from './containers/AdminLogin';
import EventDashboard from './containers/EventDashboard'
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/story" element={<Story />} />
        <Route path="/offerings" element={<Offerings />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/adminLogin" element={<AdminLogin />} />
        <Route
          path="/eventDashboard"
          element={
            <ProtectedRoute>
              <EventDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}
export default App